if(!__webpack_require__.federation){
	__webpack_require__.federation = {
		initOptions: {"name":"Appshell","remotes":[],"shareStrategy":"version-first"},
		chunkMatcher: function(chunkId) {return !/^webpack_sharing_consume_default_react_(jsx\-runtime_react_jsx\-runtime|react)$/.test(chunkId)},
		rootOutputDir: "",
		bundlerRuntimeOptions: { remotes: { remoteInfos: {}, webpackRequire: __webpack_require__,idToRemoteMap: {}, chunkMapping: {},idToExternalAndNameMapping: {} } }
	};
__webpack_require__.consumesLoadingData = {}
__webpack_require__.remotesLoadingData = {}
}